import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { useProductPhotosContext } from "../../utils/Contexts/V2/ProductPhotosContext";
import { useAuth } from "../../utils/Contexts/V2/AuthenticationContext";

function PhotoOption({ photo, showPhotoOptionHandler }) {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { showDeleteConfirmationHandler } = useProductPhotosContext();
  const [preivewImageIndex, setPreviewImageIndex] = useState(0);
  const deletePhotoHandler = () => {
    showPhotoOptionHandler(false);
    showDeleteConfirmationHandler();
  };

  const businessName = user?.business_name;
  const subdomain = user?.subdomain;
  const webLink = `https://${subdomain}.tappi.ke/photos/${photo?.id}`;
  const shareText = `You might like this product from ${businessName}! Check it out here ${webLink}`;

  const shareDialogueHandler = () => {
    if (navigator.share) {
      navigator
        .share({
          title: "Check us out!",
          text: shareText,
          url: webLink,
        })
        .then(() => console.log("Shared successfully"))
        .catch((error) => console.error("Error sharing:", error));
    }
  };

  return (
    <div className="fixed bottom-0 z-20 w-full h-screen flex bg-black/[.8]">
      <div className="w-full pt-7 px-4 pb-9 rounded-t-2xl md:rounded-2xl bg-white self-end md:self-center lg:max-w-screen-sm lg:mx-auto max-h-[95vh] overflow-y-scroll">
        <div className="w-full flex flex-row justify-between items-center pb-7 h-12">
          <h2>Product photo</h2>
          <button
            type="button"
            onClick={() => showPhotoOptionHandler(false)}
            className="h-2 w-6"
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"
                fill="black"
              />
            </svg>
          </button>
        </div>
        <div className="w-full flex flex-col items-start justify-center space-y-6 rounded-lg overflow-hidden">
          <img
            alt={photo.product_name}
            className="block object-cover w-full h-[17rem] rounded-lg"
            src={
              !photo?.product_photos
                ? photo?.photo_url
                : photo?.product_photos[preivewImageIndex]?.photo_url
            }
          />
          <div className="flex flex-row justify-start items-center space-x-[1rem] w-full py-[1rem] overflow-y-scroll">
            {photo?.product_photos?.map((productPhoto, index) => (
              <button
                onClick={() => setPreviewImageIndex(index)}
                type="button"
                className="w-20 h-20 rounded-lg  flex-shrink-0"
              >
                <img
                  key={productPhoto.id}
                  alt={photo.product_name}
                  className="w-20 h-20 rounded-lg object-cover flex-shrink-0"
                  src={productPhoto.photo_url}
                />
              </button>
            ))}
          </div>
          <div className="w-full flex flex-col justify-center items-center space-y-2">
            <div className="flex justify-between items-center w-full space-x-4">
              <p className="font-bold capitalize text-base ">
                {photo.product_name}
              </p>
              {photo.price && <p>Ksh {photo.price}</p>}
            </div>
            <button
              type="button"
              className="w-full h-12 py-[0.94rem] px-[1.3rem] flex flex-row justify-start items-center font-medium text-base rounded-lg bg-[#F0F0F0]"
              onClick={() => navigate(`/edit-photos?id=${photo.id}`)}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="mr-3"
              >
                <path
                  d="M7.1998 10.1984C7.1998 10.0393 7.26302 9.88669 7.37554 9.77417C7.48806 9.66165 7.64067 9.59844 7.7998 9.59844H16.1998C16.3589 9.59844 16.5115 9.66165 16.6241 9.77417C16.7366 9.88669 16.7998 10.0393 16.7998 10.1984C16.7998 10.3576 16.7366 10.5102 16.6241 10.6227C16.5115 10.7352 16.3589 10.7984 16.1998 10.7984H7.7998C7.64067 10.7984 7.48806 10.7352 7.37554 10.6227C7.26302 10.5102 7.1998 10.3576 7.1998 10.1984ZM7.7998 13.1984C7.64067 13.1984 7.48806 13.2617 7.37554 13.3742C7.26302 13.4867 7.1998 13.6393 7.1998 13.7984C7.1998 13.9576 7.26302 14.1102 7.37554 14.2227C7.48806 14.3352 7.64067 14.3984 7.7998 14.3984H11.3998C11.5589 14.3984 11.7115 14.3352 11.8241 14.2227C11.9366 14.1102 11.9998 13.9576 11.9998 13.7984C11.9998 13.6393 11.9366 13.4867 11.8241 13.3742C11.7115 13.2617 11.5589 13.1984 11.3998 13.1984H7.7998ZM7.1998 17.3984C7.1998 17.2393 7.26302 17.0867 7.37554 16.9742C7.48806 16.8617 7.64067 16.7984 7.7998 16.7984H13.1326L12.3286 17.6024C12.2045 17.7264 12.0891 17.8587 11.983 17.9984H7.7998C7.64067 17.9984 7.48806 17.9352 7.37554 17.8227C7.26302 17.7102 7.1998 17.5576 7.1998 17.3984ZM11.065 20.3984H6.5998C6.44067 20.3984 6.28806 20.3352 6.17554 20.2227C6.06302 20.1102 5.9998 19.9576 5.9998 19.7984V5.39844C5.9998 5.23931 6.06302 5.0867 6.17554 4.97417C6.28806 4.86165 6.44067 4.79844 6.5998 4.79844H8.5018C8.62594 5.14953 8.8559 5.45348 9.16002 5.6684C9.46413 5.88332 9.82741 5.99863 10.1998 5.99844H13.7998C14.1722 5.99863 14.5355 5.88332 14.8396 5.6684C15.1437 5.45348 15.3737 5.14953 15.4978 4.79844H17.3998C17.5589 4.79844 17.7115 4.86165 17.8241 4.97417C17.9366 5.0867 17.9998 5.23931 17.9998 5.39844V11.9312L18.1234 11.8076C18.4426 11.4884 18.8086 11.2436 19.1998 11.0768V5.39844C19.1998 4.92105 19.0102 4.46321 18.6726 4.12565C18.335 3.78808 17.8772 3.59844 17.3998 3.59844H15.4978C15.3737 3.24734 15.1437 2.94339 14.8396 2.72847C14.5355 2.51355 14.1722 2.39824 13.7998 2.39844H10.1998C9.82741 2.39824 9.46413 2.51355 9.16002 2.72847C8.8559 2.94339 8.62594 3.24734 8.5018 3.59844H6.5998C6.12242 3.59844 5.66458 3.78808 5.32701 4.12565C4.98945 4.46321 4.7998 4.92105 4.7998 5.39844V19.7984C4.7998 20.2758 4.98945 20.7337 5.32701 21.0712C5.66458 21.4088 6.12242 21.5984 6.5998 21.5984H10.8046C10.8136 21.458 10.8353 21.3186 10.8694 21.182L11.065 20.3984ZM14.3998 4.19844C14.3998 4.35757 14.3366 4.51018 14.2241 4.6227C14.1115 4.73522 13.9589 4.79844 13.7998 4.79844H10.1998C10.0407 4.79844 9.88806 4.73522 9.77554 4.6227C9.66302 4.51018 9.5998 4.35757 9.5998 4.19844C9.5998 4.03931 9.66302 3.8867 9.77554 3.77417C9.88806 3.66165 10.0407 3.59844 10.1998 3.59844H13.7998C13.9589 3.59844 14.1115 3.66165 14.2241 3.77417C14.3366 3.8867 14.3998 4.03931 14.3998 4.19844ZM13.1758 18.4508L18.9718 12.6548C19.3929 12.2341 19.9638 11.9979 20.5591 11.9981C21.1543 11.9983 21.7251 12.235 22.1458 12.656C22.5665 13.0771 22.8028 13.648 22.8026 14.2433C22.8023 14.8385 22.5657 15.4093 22.1446 15.83L16.3486 21.6248C16.011 21.9626 15.5879 22.2024 15.1246 22.3184L13.327 22.7672C13.1483 22.8118 12.961 22.8093 12.7835 22.7601C12.606 22.7109 12.4442 22.6167 12.3139 22.4865C12.1836 22.3563 12.0892 22.1946 12.0398 22.0171C11.9904 21.8396 11.9878 21.6524 12.0322 21.4736L12.4822 19.676C12.5973 19.2124 12.8372 18.789 13.1758 18.452V18.4508Z"
                  fill="#566370"
                />
              </svg>
              Edit product photo
            </button>
            <button
              type="button"
              className="w-full h-12 py-[0.94rem] px-[1.3rem] flex flex-row justify-start items-center font-medium text-base rounded-lg bg-[#F0F0F0]"
              onClick={shareDialogueHandler}
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="mr-3"
              >
                <path
                  d="M12.6885 10.9688C12.1318 10.9688 11.6182 11.1641 11.2158 11.4902L7.16895 8.5625C7.23671 8.19056 7.23671 7.80944 7.16895 7.4375L11.2158 4.50977C11.6182 4.83594 12.1318 5.03125 12.6885 5.03125C13.9814 5.03125 15.0322 3.98047 15.0322 2.6875C15.0322 1.39453 13.9814 0.34375 12.6885 0.34375C11.3955 0.34375 10.3447 1.39453 10.3447 2.6875C10.3447 2.91406 10.376 3.13086 10.4365 3.33789L6.59277 6.12109C6.02246 5.36523 5.11621 4.875 4.09473 4.875C2.36816 4.875 0.969727 6.27344 0.969727 8C0.969727 9.72656 2.36816 11.125 4.09473 11.125C5.11621 11.125 6.02246 10.6348 6.59277 9.87891L10.4365 12.6621C10.376 12.8691 10.3447 13.0879 10.3447 13.3125C10.3447 14.6055 11.3955 15.6562 12.6885 15.6562C13.9814 15.6562 15.0322 14.6055 15.0322 13.3125C15.0322 12.0195 13.9814 10.9688 12.6885 10.9688ZM12.6885 1.67188C13.249 1.67188 13.7041 2.12695 13.7041 2.6875C13.7041 3.24805 13.249 3.70312 12.6885 3.70312C12.1279 3.70312 11.6729 3.24805 11.6729 2.6875C11.6729 2.12695 12.1279 1.67188 12.6885 1.67188ZM4.09473 9.71875C3.14746 9.71875 2.37598 8.94727 2.37598 8C2.37598 7.05273 3.14746 6.28125 4.09473 6.28125C5.04199 6.28125 5.81348 7.05273 5.81348 8C5.81348 8.94727 5.04199 9.71875 4.09473 9.71875ZM12.6885 14.3281C12.1279 14.3281 11.6729 13.873 11.6729 13.3125C11.6729 12.752 12.1279 12.2969 12.6885 12.2969C13.249 12.2969 13.7041 12.752 13.7041 13.3125C13.7041 13.873 13.249 14.3281 12.6885 14.3281Z"
                  fill="#566370"
                />
              </svg>
              Share product photo
            </button>

            <button
              type="button"
              className="w-full h-12 py-[0.94rem] px-[1.3rem] flex flex-row justify-start items-center font-medium text-base rounded-lg bg-[#F0F0F0]"
              onClick={deletePhotoHandler}
            >
              <svg
                width="20"
                height="22"
                viewBox="0 0 20 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="mr-3"
              >
                <path
                  d="M7.85798 4.14293H12.1437C12.1437 3.57461 11.9179 3.02956 11.5161 2.6277C11.1142 2.22583 10.5692 2.00007 10.0008 2.00007C9.43252 2.00007 8.88747 2.22583 8.48561 2.6277C8.08374 3.02956 7.85798 3.57461 7.85798 4.14293ZM6.57227 4.14293C6.57227 3.23361 6.93349 2.36154 7.57647 1.71856C8.21945 1.07558 9.09152 0.714355 10.0008 0.714355C10.9102 0.714355 11.7822 1.07558 12.4252 1.71856C13.0682 2.36154 13.4294 3.23361 13.4294 4.14293H18.7866C18.957 4.14293 19.1206 4.21066 19.2411 4.33122C19.3617 4.45177 19.4294 4.61529 19.4294 4.78578C19.4294 4.95628 19.3617 5.11979 19.2411 5.24035C19.1206 5.36091 18.957 5.42864 18.7866 5.42864H17.6637L16.6206 17.9455C16.5447 18.8561 16.1293 19.7049 15.457 20.3236C14.7846 20.9423 13.9043 21.2857 12.9906 21.2858H7.01112C6.0974 21.2857 5.21707 20.9423 4.5447 20.3236C3.87233 19.7049 3.45702 18.8561 3.38112 17.9455L2.33798 5.42864H1.21512C1.04463 5.42864 0.881113 5.36091 0.760554 5.24035C0.639995 5.11979 0.572266 4.95628 0.572266 4.78578C0.572266 4.61529 0.639995 4.45177 0.760554 4.33122C0.881113 4.21066 1.04463 4.14293 1.21512 4.14293H6.57227ZM4.66255 17.8384C4.71157 18.4276 4.98023 18.9768 5.41525 19.3772C5.85027 19.7777 6.41988 20 7.01112 20.0001H12.9906C13.5818 20 14.1514 19.7777 14.5864 19.3772C15.0214 18.9768 15.2901 18.4276 15.3391 17.8384L16.3746 5.42864H3.62798L4.66255 17.8384ZM8.07227 8.42864C8.24276 8.42864 8.40627 8.49637 8.52683 8.61693C8.64739 8.73749 8.71512 8.901 8.71512 9.0715V16.3572C8.71512 16.5277 8.64739 16.6912 8.52683 16.8118C8.40627 16.9323 8.24276 17.0001 8.07227 17.0001C7.90177 17.0001 7.73826 16.9323 7.6177 16.8118C7.49714 16.6912 7.42941 16.5277 7.42941 16.3572V9.0715C7.42941 8.901 7.49714 8.73749 7.6177 8.61693C7.73826 8.49637 7.90177 8.42864 8.07227 8.42864ZM12.5723 9.0715C12.5723 8.901 12.5045 8.73749 12.384 8.61693C12.2634 8.49637 12.0999 8.42864 11.9294 8.42864C11.7589 8.42864 11.5954 8.49637 11.4748 8.61693C11.3543 8.73749 11.2866 8.901 11.2866 9.0715V16.3572C11.2866 16.5277 11.3543 16.6912 11.4748 16.8118C11.5954 16.9323 11.7589 17.0001 11.9294 17.0001C12.0999 17.0001 12.2634 16.9323 12.384 16.8118C12.5045 16.6912 12.5723 16.5277 12.5723 16.3572V9.0715Z"
                  fill="#566370"
                />
              </svg>
              Delete photo
            </button>
          </div>

          <button
            type="button"
            className="w-full h-12 text-white text-base font-medium rounded-xl bg-primary-50 thryve:text-base"
            onClick={() => showPhotoOptionHandler(false)}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

PhotoOption.defaultProps = {
  photo: null,
};

PhotoOption.propTypes = {
  photo: PropTypes.objectOf(PropTypes.string),
  showPhotoOptionHandler: PropTypes.func.isRequired,
};

export default PhotoOption;
